import React from 'react';
import IndustryPageTemplate from '../../components/IndustryPageTemplate';
import SEO from '../../components/SEO';

const CleaningService = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How can Local Business Heroes help my cleaning service business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Local Business Heroes helps cleaning service businesses capture more leads, automate follow-ups, reduce no-shows, and grow faster. Rated 4.9/5 by 1,200+ UK businesses."
        }
      },
      {
        "@type": "Question",
        "name": "How much does it cost for cleaning service businesses?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Plans start at £297/month with a 14-day trial for just £5. Most cleaning service businesses see ROI within the first month."
        }
      },
      {
        "@type": "Question",
        "name": "Do I need technical skills to use it?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No. Local Business Heroes is designed for busy business owners with zero tech experience. Setup takes 5 minutes with UK-based support."
        }
      },
      {
        "@type": "Question",
        "name": "Will it work for my cleaning service business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. Local Business Heroes is specifically designed for local service businesses like cleaning service. Features include appointment scheduling, automated reminders, lead capture, and customer management."
        }
      }
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "CRM for Cleaning Service - Local Business Heroes",
    "applicationCategory": "BusinessApplication",
    "offers": {
      "@type": "Offer",
      "price": "297",
      "priceCurrency": "GBP"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "1200"
    }
  };

  const breadcrumbs = [
    { name: "Home", url: "/" },
    { name: "Industries", url: "/industries" },
    { name: "Cleaning Service CRM", url: "/industries/cleaning-service" }
  ];

  const industryData = {
    name: 'Cleaning Service',
    title: 'Stop Chasing Clients & Fill Your Schedule with Recurring Contracts',
    subtitle: 'Automate booking confirmations, send service reminders, and convert one-time cleans into monthly contracts',
    icon: '🧹',
    challenges: [
      'Too much time spent on phone calls and scheduling',
      'Difficult to convert one-time clients to recurring',
      'Last-minute cancellations leaving gaps in schedule',
      'Hard to follow up on quotes',
      'Manual invoice and payment tracking'
    ],
    solutions: [
      'Online booking with instant confirmations',
      'Automated recurring service reminders',
      'Smart follow-up on quotes converts 40% more',
      'Automatic reminder system reduces cancellations',
      'Integrated payment and invoice automation'
    ],
    features: [
      'Client CRM with service history',
      'Online booking and scheduling',
      'Automated quote follow-ups',
      'Recurring service automation',
      'SMS/email reminders 24 hours before service',
      'Review requests after each clean',
      'Before/after photo galleries',
      'Payment processing integration'
    ],
    results: [
      '65% of clients convert to recurring',
      '40% fewer cancellations',
      'Book 3x more jobs per week',
      '£4.1K average monthly revenue increase'
    ]
  };

  return (
    <>
      <SEO 
        title="CRM for Cleaning Service UK | Marketing Automation | Local Business Heroes"
        description="Rated 4.9/5. CRM and marketing automation for cleaning service businesses. Capture more leads, automate follow-up, grow faster. Start £5 trial today."
        keywords="CRM for cleaning service UK, cleaning service business software, cleaning service customer management, cleaning service lead generation UK"
        url="/industries/cleaning-service"
        schemaMarkup={[faqSchema, localBusinessSchema]}
        breadcrumbs={breadcrumbs}
      />
      <IndustryPageTemplate industry={industryData} />
    </>
  );
};

export default CleaningService;